import {useMutation} from "@tanstack/react-query";

import {removeLeadNoteMutationOptions} from "./remove-lead-note.mutation-options";

export function useRemoveLeadNote(leadId: string) {
  return useMutation(removeLeadNoteMutationOptions(leadId));
}
